import { Link } from 'react-router-dom';
import { blogPosts } from '../data/blogposts';
import usePageMeta from '../hooks/usePageMeta';

export default function Blog() {
  usePageMeta({
    title: 'Ajankohtaista',
    description: 'Pulmakiven uutiset ja päivitykset. Lue uusimmat kuulumiset Norppa-ristikkosovelluksesta.',
    canonical: 'https://pulmakivi.fi/ajankohtaista',
  });

  return (
    <div>
      <h1 className="page__title">Ajankohtaista</h1>
      <div className="blog-list">
        {blogPosts.map((post) => (
          <Link to={`/ajankohtaista/${post.slug}`} key={post.slug} className="blog-card">
            <article>
              <h2 className="blog-card__title">{post.title}</h2>
              <p className="blog-card__meta">{post.date} · {post.author}</p>
              <p className="blog-card__intro">{post.intro}</p>
              <span className="blog-card__link">Lue lisää</span>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
}
